import React, { useState, useEffect, useContext } from 'react'
import {
  AppContainer,
  GlobalStyle,
  Loading,
  useBlurAndAbove,
  SFXS,
} from '@orbital/games-frontend-library'

import Game from './Game'
import { colors } from '../lib/colors'

import { DICE_PROPS } from './interfaces'
import Settings from '../pages/settings/Settings'
import ProvablyFair from '../pages/provably/Provably'
import GameRules from '../pages/gameRules/gameRules'
import History from '../pages/history/History'
import { useHandlePopup } from '../helpers/useHandlePopup'
import BetReply from '../pages/betReply/BetReply'
import Layer from '../pages/layer/Layer'
import { sendAudio, useSettings } from '../settings/useSettings'
import { useCustomLoader } from '../pages/loader/Loader'
import Error from '../components/elements/Error/Error'
import { handleBackgroundSFX } from '../helpers/playBackground'
import { MyContext } from '../context/createContext'
import { defaultContext } from '../context/defaultContext'
import { Currencies } from '../helpers/currency/getCurrencySymbol'
import { ErrorTexts } from '../lib/constants'

export default function CyberDice({ errorCode }: DICE_PROPS) {
  const { context } = useContext(MyContext)
  const {
    pf,
    auth,
    handleNotification,
    bet_reply,
    notificationfadeOut,
    notification,
    isError,
    errorText,
    globalSocketMessages,
    history,
    settings,
    handleAutoConfigCTX,
    handleErrorText,
  } = context
  const [autoPlayIsOn, setAutoPlay] = useState(false)
  const [blur, , settingsUnblur, above, handleAbove] = useBlurAndAbove()
  const [layer, popup, handlePopup] = useHandlePopup()
  const [roundId, setRoundId] = useState<string>('')
  const [audio, setAudio] = useState(defaultContext.settings.audio)
  const prec = Currencies[auth.balance.currency]
    ? Currencies[auth.balance.currency].precision
    : 2
  const curr = Currencies[auth.balance.currency]
    ? Currencies[auth.balance.currency].symbol
    : ''
  useEffect(() => {
    setAudio(settings.audio)
  }, [settings])

  useEffect(() => {
    if (settings.configs) {
      const one = settings.configs.configOne
      const two = settings.configs.configTwo
      const tree = settings.configs.configThree
      one.isSaved === '1' && handleAutoConfigCTX(one, 'autoConfigOne')
      two.isSaved === '1' && handleAutoConfigCTX(two, 'autoConfigTwo')
      tree.isSaved === '1' && handleAutoConfigCTX(tree, 'autoConfigThree')
    }
  }, [settings.configs])

  const handleAudio = (a: any) => sendAudio(a, settings)
  const handleRoundId = (s: string) => setRoundId(s)

  const settingsFromSocket = useSettings(globalSocketMessages)

  const [showLoader, duration] = useCustomLoader(
    handleAbove,
    auth.player_id,
    isError,
  )
  useEffect(() => {
    above && !audio.isSoundOff && SFXS.goForwardSFX.play()
  }, [above])

  handleBackgroundSFX(audio, errorText, showLoader)

  const errorClickHandler = () => {
    isError ? '' : handleNotification(false)
  }
  useEffect(() => {
    if (!Currencies[auth.balance.currency]) {
      handleErrorText(ErrorTexts.CURRENCY_NOT_SUPPOTRTED)
    }
  }, [auth.balance.currency])

  return (
    <AppContainer color={colors.primary}>
      <GlobalStyle />
      <Game
        blur={blur}
        handleAbove={handleAbove}
        handleRoundId={handleRoundId}
        handlePopup={handlePopup}
        showLoader={showLoader}
        history={history}
        handleSetAutoConfig={(b: boolean) => setAutoPlay(b)}
        errorCode={errorCode}
        audio={audio}
      />
      {above === 'settings' && (
        <Settings
          handleAbove={handleAbove}
          unBlur={settingsUnblur}
          handleAudio={handleAudio}
          audioForSocket={settings.audio}
          audio={audio}
        />
      )}
      {above === 'Provably Fair' && (
        <ProvablyFair
          handleAbove={handleAbove}
          seeds={{
            ...pf,
            next_server_seed_SHA256: pf.next_server_seed_hash,
            server_seed_SHA256: pf.server_seed_hash,
            old_client_seed: pf.previous_client_seed,
            old_server_seed: pf.previous_server_seed,
            old_nonce: pf.previous_nonce,
            old_server_seed_SHA256: pf.previous_server_seed_hash,
          }}
          handleNotification={handleNotification}
          notification={notification}
          seedRequest={globalSocketMessages.seedRequest}
          newSeedRequest={globalSocketMessages.newSeedRequest}
          autoPlayIsOn={autoPlayIsOn}
          audio={audio}
        />
      )}
      {above === 'Game Rules' && (
        <GameRules
          handleAbove={handleAbove}
          audio={audio}
          prec={prec}
          curr={curr}
        />
      )}
      {above === 'History' && (
        <History
          handleAbove={handleAbove}
          history={history}
          requestBetReply={globalSocketMessages.requestBetReply}
          handleRoundId={handleRoundId}
          handlePopup={handlePopup}
          audio={audio}
          prec={prec}
        />
      )}
      {(layer || isError) && <Layer />}
      {popup === 'Bet Reply' && (
        <BetReply
          handlePopup={handlePopup}
          handleNotification={handleNotification}
          betReply={bet_reply}
          id={auth.player_id}
          audio={audio}
          roundId={roundId}
          prec={prec}
        />
      )}
      {showLoader && <Loading duration={duration} />}
      {(!!notification || errorText) && (
        <Error
          fadeOut={notificationfadeOut}
          text={notification || errorText}
          error={isError}
          clickHandler={errorClickHandler}
          showLoader={showLoader}
          audio={audio}
        />
      )}
    </AppContainer>
  )
}
